import { render, staticRenderFns } from "./EndorsementsApproved.vue?vue&type=template&id=3a76a3e5&scoped=true&"
import script from "./EndorsementsApproved.vue?vue&type=script&lang=js&"
export * from "./EndorsementsApproved.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementsApproved.vue?vue&type=style&index=0&id=3a76a3e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a76a3e5",
  null
  
)

export default component.exports